/* eslint-disable */
/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// validate that te 
const projectIdLocalStorage = parseInt(localStorage.getItem('selectedProjectId')) || null;

// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  const mq = function (query) {
    return window.matchMedia(query).matches;
  }

  if (('ontouchstart' in window) || window.DocumentTouch) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////
const state = {
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  is_touch_device: is_touch_device(),
  navbarSearchAndPinList: navbarSearchAndPinList,
  reduceButton: themeConfig.sidebarCollapsed,
  verticalNavMenuWidth: "default",
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  theme: themeConfig.theme || "light",
  themePrimaryColor: colors.primary,
  projectId: projectIdLocalStorage,
  authorizedProjects:[],
  powerbiConfigurations: {
    powerBiGroupId: "",
    gradeControl: "",
    gradeControlTimesheet: "",
    gradeControlStockPile: "",
    gradeControlMuck: "",
    gradeControlDailyLocationStats: "",
    gradeControlLocationSummaryStats: "",
    gradeControlDeswikExport: "",
    gradeControlOdysseyDeswikExport: "",
    gradeControlDetourDeswikExport: "",
    gradeControlSamples: "",
    cashFlowGroupId: "",
    cashflow: "",
    cashflowCalculated: "",
    businessStrategyKpu: "",
    businessStrategyKpuPaginated: "",
    geoStatsGroupId: "",
    geoQAQC: "",
    mrmrGroupId: "",
    mrmrDashboard: "",
    mrmrRawData: "",
    mrmrConsolidated: "",
    mrmrPerCommodity: "",
    mrmrComparison: "",
    drillingGroupId: "",
    drillingDashboard: "",
    drillingOptimized: "",
    drillingAnalytics : "",
    decarbonizationGroupId: "",
    decarbonization: ""
  },
  activeDirectoryConfigurations: {
    cashflowProjectLeadersGroupId: "", 
    mrmrQpGeologyGroupId: "",
    mrmrQpEngineergingGroupId: ""
  },
  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null,
  appBootstrapCompleted: false
}

export default state
